import MyfeedInfo from "../../Community/Components/MyfeedInfo";
import MyPosts from "../../Community/Components/MyPosts";
import UserCompo from "../../Community/Components/UserCompo";
import SingleBlogsScreen from "./SingleBlogsScreen";

const BlogsSinglePage = () => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        padding: "20px",
        height: "85vh",
        backgroundColor: "#F4F7FE",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          width: "25%",
          textAlign: "left",
          margin: "10px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            minHeight: "80vh",
            overflowY: "scroll",
            scrollbarWidth: "none",
            scrollBehavior: "smooth",
          }}
        >
          <UserCompo />
          <MyPosts />
          <MyfeedInfo />
        </div>
      </div>
      <div
        style={{
          width: "70%",
          // height: "100vh",
          // overflowY: "sroll",
          scrollbarWidth: "none",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          // background: "#fff",
        }}
      >
        <div
          style={{
            height: "80vh",
            overflowY: "scroll",
            scrollbarWidth: "none",
          }}
        >
          <SingleBlogsScreen />
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default BlogsSinglePage;
